import AppRouter from "./app-router"
export default AppRouter
